import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { Section } from 'ui/molecules/Section/Section';

import styles from './CompanyDataRegis.module.scss';

export const CompanyDataRegis = () => {
  const { t } = useInt();

  const FACTS = [
    {
      title: t('Why it matters for agents'),
      desc: t(
        "An agent on a general-purpose model will produce a turnover figure for any company you name. Regis returns nothing it did not read from a register on that request, so the agent's output inherits the same constraint.",
      ),
    },
    {
      title: t('How it fits'),
      desc: (
        <>
          {t('Call')} <span className={styles.code}>POST /v1/regis/query</span>{' '}
          {t(
            'with a question, or expose it through the MCP server as a tool for multi-step questions such as a full ownership chain. Structured endpoints remain available alongside it.',
          )}
        </>
      ),
    },
    {
      title: t('What comes back'),
      desc: t(
        'The written answer, the resolved entities, the fields used and the source records, in JSON. Written straight into a case management system without parsing prose.',
      ),
    },
  ];

  return (
    <Section
      className={styles.root}
      theme="dark"
      layout="split"
      splitAlign="top"
      title={
        <>
          {t('Grounding an LLM and retrieving a record are')} <span>{t('two different things.')}</span>
        </>
      }
      description={t(
        'AI grounding adds context to a model that still answers from its weights. Regis is the retrieval-and-answer layer over this dataset. It runs on our own hardware, calls no third-party model API and holds no company facts in its weights. When a question asks for a field the register does not publish, it returns the gap and the reason. It does not fill it.',
      )}
      actions={
        <Button type="white-outline" size="lg" rounded="full" href="/regis-api">
          {t('See Regis decline a question it cannot source')}
        </Button>
      }
    >
      <div className={styles.facts}>
        {FACTS.map((fact, i) => (
          <div key={fact.title} className={styles.fact}>
            <span className={styles.factNum}>{String(i + 1).padStart(2, '0')}</span>
            <div>
              <b>{fact.title}</b>
              <p>{fact.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
};
